"use strict";

// Module API

function checkEnum(constraint, value) {
  if (value === null) {
    return true;
  }
  if (constraint.includes(value)) {
    return true;
  }
  return false;
}

module.exports = {
  checkEnum: checkEnum
};


//////////////////
// WEBPACK FOOTER
// ./~/tableschema/lib/constraints/enum.js
// module id = 322
// module chunks = 0